/** sets filters on baseQuery, by reference */
export async function applyFiltersToQuery(
  baseQuery,
  filters,
  facetDetails,
  filterType
) {
  baseQuery.resetAllFilters();
  const activeFilters = Object.keys(filters);

  if (activeFilters.length === 0) return baseQuery;

  for (const filterKey of activeFilters) {
    const filterDetail = facetDetails[filterKey];

    const filterValue = filters[filterKey];

    switch (filterDetail.component) {
      case "StringFilter": {
        if (filterKey === "search" && filterValue) {
          baseQuery.search(filterValue.replaceAll('"', ""));
          baseQuery.searchFieldsByProperty = {
            root: [
              "id",
              "title",
              "acronym",
              "collections.id",
              "collections.title",
              "collections.acronym",
              "collections.diagnosis_available.name",
              "collections.diagnosis_available.code",
              "collections.diagnosis_available.label",
              "collections.diagnosis_available.definition",
              "collections.materials.name",
              "collections.materials.label",
            ],
            collections: [
              "id",
              "title",
              "acronym",
              "in_series.title",
              "diagnosis_available.name",
              "diagnosis_available.code",
              "diagnosis_available.label",
              "diagnosis_available.definition",
            ],
          };
        } else {
          /** add filters to Biobanks */
          baseQuery.orWhere("id").like(filterValue);
          baseQuery.orWhere("name").like(filterValue);
          baseQuery.orWhere("acronym").like(filterValue);
          baseQuery.orWhere("collections.id").like(filterValue);
          baseQuery.orWhere("collections.title").like(filterValue);
          baseQuery.orWhere("collections.acronym").like(filterValue);
          baseQuery.orWhere("collections.condition.name").like(filterValue);
          baseQuery.orWhere("collections.condition.code").like(filterValue);
          baseQuery.orWhere("collections.condition.label").like(filterValue);
          baseQuery.orWhere("collections.condition.definition").like(filterValue);
          baseQuery.orWhere("collections.body_part_examined.label").like(filterValue);

          /** and filter the collections */
          baseQuery.orFilter("collections.id").like(filterValue);
          baseQuery.orFilter("collections.title").like(filterValue);
          baseQuery.orFilter("collections.acronym").like(filterValue);
          baseQuery.orFilter("collections.biobank.title").like(filterValue);
          baseQuery.orFilter("collections.condition.name").like(filterValue);
          baseQuery.orFilter("collections.condition.code").like(filterValue);
          baseQuery.orFilter("collections.condition.label").like(filterValue);
          baseQuery.orFilter("collections.condition.definition").like(filterValue);
          baseQuery.orFilter("collections.body_part_examined.label").like(filterValue);
        }

        /** cant search in the search box on any filter that is set to 'adaptive' because the items will not show. */
        break;
      }
      case "ToggleFilter":
      case "ServiceFilter":
      case "CheckboxFilter": {
        const values = Array.isArray(filterValue)
          ? filterValue.map((fv) => fv.value)
          : [filterValue];
        const columns = Array.isArray(filterDetail.applyToColumn)
          ? filterDetail.applyToColumn
          : [filterDetail.applyToColumn];

        for (const column of columns) {
          if (
            filterType[filterDetail.facetIdentifier] === "all" ||
            values.length === 1
          ) {
            if (typeof values[0] === "boolean") {
              for (const value of values) {
                baseQuery.where(column).equals(value);
                baseQuery.filter(column).equals(value);
              }
            } else {
              baseQuery.where(column).in(values);
              baseQuery.filter(column).in(values);
            }
          } else {
            if (typeof values[0] === "boolean") {
              for (const value of values) {
                baseQuery.orWhere(column).equals(value);
                baseQuery.orFilter(column).equals(value);
              }
            } else {
              baseQuery.orWhere(column).in(values);
              baseQuery.orFilter(column).in(values);
            }
          }
        }
        break;
      }
      case "OntologyFilter": {
        const values = filterValue.map((filterValue) => filterValue.code);
        if (
          filterType[filterDetail.facetIdentifier] === "all" ||
          values.length === 1
        ) {
          baseQuery.where(filterDetail.applyToColumn).in(values);
          baseQuery.filter(filterDetail.applyToColumn).in(values);
        } else {
          baseQuery.orWhere(filterDetail.applyToColumn).in(values);
          baseQuery.orFilter(filterDetail.applyToColumn).in(values);
        }
        break;
      }
    }
  }
  return baseQuery;
}
